import React from 'react';
import './KPIPerformance.css';

const KPIPerformance = () => {
    return (
        <div className="page-container">
            <div className="placeholder-content">
                <h2>KPI & Performance</h2>
                <p>KPI analytics and performance metrics coming soon...</p>
            </div>
        </div>
    );
};

export default KPIPerformance;
